import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
	apiEndpoint: string;
	title: string;
	storageLoginKey: string;
	storageResourcesKey: string;
	saveLogs: boolean;
	lmsBaseUrl: string;
	pageSize: number;
	sessionTimeOut: number;
	videolibraryapiurl: string;
	videoLibraryThumbnailApiUrl: string;
	searchApiEndpoint: string;
	storageSearchApiKey: string;
	hostName: string;
	dashboardViewerUrl: string;
	apiBaseUrl: string;
}

export const WIZDOM_APP_CONFIG: AppConfig = {
	// /*Define all global level constants*/
	apiEndpoint: environment.apiEndpoint,
	apiBaseUrl: environment.apiBaseUrl,
	searchApiEndpoint: environment.searchApiEndpoint,
	title: environment.title,
	saveLogs: environment.saveLogs,
	storageLoginKey: environment.storageLoginKey,
	storageResourcesKey: environment.storageResourcesKey,
	storageSearchApiKey: environment.storageSearchApiKey,
	hostName: environment.hostName,
	lmsBaseUrl: environment.lmsBaseUrl,
	pageSize: 10,
	sessionTimeOut: 1200,
	videolibraryapiurl: environment.videolibraryapiurl,
	videoLibraryThumbnailApiUrl: environment.videoLibraryThumbnailApiUrl,
	dashboardViewerUrl: environment.dashboardViewerUrl
};
